import { Button } from '@material-ui/core';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'

import styles from './styles.module.scss'

const PDVS = ({ pdv }) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.gray}>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Ponto de venda:
                    </div>
                    <div className={styles.info}>
                        { pdv.nomeParceiro }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        CNPJ:
                    </div>
                    <div className={styles.info}>
                        { pdv.cnpj }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Cód. Parceiro:
                    </div>
                    <div className={styles.info}>
                        { pdv.codigoParceiro }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Classificação geral:
                    </div>
                    <div className={styles.info}>
                        { pdv.classificacaoGeral }
                    </div>
                </div>
                <div className={styles.infoWrapper}>
                    <div className={styles.label}>
                        Total de pontos:
                    </div>
                    <div className={styles.info}>
                        { pdv.totalPontos }
                    </div>
                </div>
            </div>
            <div className={`${styles.gray} ${styles.seeWrapper}`}>
                <Button className={styles.see} href={`/desempenho/detalhes/${pdv.idDesempenho}`}>
                    Visualizar
                    <FontAwesomeIcon icon={faEye} className={styles.icon}/>
                </Button>
            </div>
        </div>
    )
}

export default PDVS